import img1 from '/static/img/experience/activities/immersiveTour/img1.png'
import img2 from '/static/img/experience/activities/immersiveTour/img2.png'
import img3 from '/static/img/experience/activities/immersiveTour/img3.png'
import img4 from '/static/img/experience/activities/immersiveTour/img4.png'
import img5 from '/static/img/experience/activities/immersiveTour/img5.png'
import img6 from '/static/img/experience/activities/immersiveTour/img6.png'
const immersiveTour = {
    title:'Immersive Tour',
    desc:'We offer a variety of activities to enrich your journey.',
    tabList:[
        {
            id:1,
            title:'natural scenery',
        },
        {
            id:2,
            title:'landmark',
        },
        {
            id:3,
            title:'City landmarks and museums',
        },
        {
            id:4,
            title:'shopping',
        },
        {
            id:5,
            title:'Local events',
        },
        {
            id:6,
            title:'special ceremonies',
        },
    ],
    contentList:[
        {
            id:1,
            title:'A variety of world-class natural landscapes',
            img:img1,
            desc:'Immerse yourself in the experience of visiting snow-capped mountains and grassland lakes at an altitude of over 4,000 meters, as well as the world-class scenic spot of Jiuzhaigou.',
        },
        {
            id:2,
            title:'Tibetan stupa',
            img:img2,
            desc:'Admire iconic architecture and experience different cultures at various destinations, including unique local features such as Tibetan stupas, which represent purity and sanctity.',
        },
        {
            id:3,
            title:'City trips and museums',
            img:img3,
            desc:'Let us take you on a tour of historic Chinese architecture or modern technological buildings. When you visit famous museums or exhibitions, you can enjoy VIP access to skip the lines and learn about your destination through art and historical culture.',
        },
        {
            id:4,
            title:'shopping',
            img:img4,
            desc:'Browse a variety of markets and shopping malls. Explore folk art and local handicrafts, such as crafts and intangible cultural heritage products. At the same time, visit comprehensive shopping malls that combine modern and ancient styles for a rich experience.',
        }
        , {
            id:5,
            title:'Local events',
            img:img5,
            desc:'On each different route, the sightseeing tour will take you to stunning scenery; different regions with different landscapes offer various activities, including the Yi ethnic group\'s Torch Festival or Sichuan\'s comedic face-changing performances, among others.',
        }
        , {
            id:6,
            title:'special ceremonies',
            img:img6,
            desc:'Experience cultural activities that have been passed down for five thousand years in China; visit the Zigong Lantern Festival in Sichuan during special holidays and immerse yourself in the world-famous Liuyang Fireworks Festival.',
        }
    ]
}
export default {
    immersiveTour
};